// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2DxBe","text":"SelectPayment_text__blw4p","title":"SelectPayment_title__3sArM","btn":"SelectPayment_btn__wcOl9"};